(function () {
  // Guards against the script tag being included more than once on the same
  // page (e.g. the icons section AND a counter theme block both render it):
  // without this, a second inclusion would set up a second IntersectionObserver
  // over the same .counter elements.
  if (window.__iconsCounterInit) return;
  window.__iconsCounterInit = true;

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = +entry.target.textContent;
        startCounting(entry.target, target);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  function startCounting(element, target) {
    let current = 0;
    const duration = 1500;
    const increment = target / 100;

    const timer = setInterval(() => {
      current += increment;
      element.textContent = Math.floor(current);

      if (current >= target) {
        clearInterval(timer);
        element.textContent = target;
      }
    }, duration / 100);
  }

  // Marks each .counter as it's picked up, so a re-scan (theme editor
  // re-render) only observes counters that weren't already handled, instead
  // of the original one-shot querySelectorAll that never re-ran and so never
  // saw a counter added or re-rendered after the initial page load.
  function scanCounters() {
    document.querySelectorAll('.counter:not([data-counter-observed])').forEach((counter) => {
      counter.setAttribute('data-counter-observed', '');
      observer.observe(counter);
    });
  }

  scanCounters();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', scanCounters);
  }
})();
